<template>
    <div id="drop">
        <!-- <div>拖拽页面展示</div> -->
        <div class="content">
            <!-- <div class="grid">
                <div class="item">
                    <div class="item-content"><searchBar></searchBar></div>
                </div>
                <div class="item">
                    <div class="item-content"><MonthlyStats></MonthlyStats></div>
                </div>
                <div class="item">
                    <div class="item-content"><ApplyTrend2></ApplyTrend2></div>
                </div>
                <div class="item">
                    <div class="item-content"><ApplyTrend></ApplyTrend></div>
                </div>
            </div> -->

                  <v-row class="grid mb-12">
                    <v-col class="item" style="height: 140px;" sm="12" md="12" lg="12">
                        <div class="item-content">
                            <searchBar></searchBar>
                        </div>
                    </v-col>
                    <v-col class="item" sm="12" md="6" lg="6">
                        <div class="item-content">
                        <MonthlyStats></MonthlyStats>
                        </div>
                    </v-col>
                    <v-col class="item" sm="12" md="6" lg="6">
                        <div class="item-content">
                        <ApplyTrend2></ApplyTrend2>
                        </div>
                    </v-col>
                    <v-col class="item" sm="12" md="6" lg="6">  
                        <div class="item-content">   
                        <ApplyTrend></ApplyTrend>
                        </div>
                    </v-col>
                    <v-col class="item" sm="12" md="6"  lg="6">
                        <div class="item-content">
                        <ProvinceChart></ProvinceChart>
                        </div>
                    </v-col>
                </v-row>
        </div>
    </div>
</template>
<script src="https://cdnjs.cloudflare.com/ajax/libs/web-animations/2.3.2/web-animations.min.js"></script>
<!-- <script src="https://cdn.jsdelivr.net/gh/haltu/muuri@0.9.3/dist/muuri.min.js"></script>-->
<script>
import ApplyTrend from "@/components/widgets/applyTrend.vue";
import ApplyTrend2 from "@/components/widgets/applyTrend2.vue";
import searchBar from "@/components/widgets/searchBar.vue";
import ProvinceChart from "@/components/widgets/ProvinceChart.vue";
import MonthlyStats from "@/components/widgets/monthlyStats.vue";
import Muuri from 'muuri'
export default {
    data() {
        return {

        }
    },
    mounted() {
        var grid = new  Muuri('.grid', {
            dragEnabled: true,
            layout: {
                fillGaps: true
            }
            // dragContainer: document.getElementById('drop'),
        });
        window.addEventListener('load', function () {
            grid.refreshItems().layout();
            // For a little finishing touch, let's fade in
            // the images after all them have loaded and
            // they are corrertly positioned.
            document.body.classList.add('images-loaded');
        });
    },
    components: {
        searchBar,
        ApplyTrend,
        ApplyTrend2,
        ProvinceChart,
        MonthlyStats,
  },
}
</script>
<style scoped>
/* .item-content {
  position: relative;
  width: 100%;
  height: 100%;
  text-align: center;
  background: red;
  font-size: 50px;
  color: white;
  cursor: pointer;
} */
 .grid {
  position: relative;
}
/* .item {
  display: block;
  position: absolute;
  width: 400px;
  height: 200px;
  margin: 5px;
  z-index: 1;
  background: #000;
  color: #fff;
}
.item:nth-child(1) {
    width: 100%;
    height: 200px;
} */
.item.muuri-item-dragging {
  z-index: 3;
}
.item.muuri-item-releasing {
  z-index: 2;
}
.item.muuri-item-hidden {
  z-index: 0;
}
.item-content {
  position: relative;
  width: 100%;
  height: 100%;
} 
</style>